export default "__VITE_ASSET__1a0becd7__"